import { lazy } from "react";
// Medication Reconciliation.
const MedicationReconciliationPage = lazy(() => import("./MedicationReconciliationPage"));
export const medicationReconciliationRoutes = [
  { path: "/MedicationReconciliationPage", element: <MedicationReconciliationPage /> },
];

export { MedicationReconciliationPage };
